import { render } from "./MenuButton.vue?vue&type=template&id=5bd8e108&scoped=true&ts=true"
import script from "./MenuButton.vue?vue&type=script&lang=ts"
export * from "./MenuButton.vue?vue&type=script&lang=ts"

import "./MenuButton.vue?vue&type=style&index=0&id=5bd8e108&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd8e108"]])

export default __exports__